/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Tampilan_TInputs */

const en_tut_tampilan_t = /** @type {(inputs: Tut_Tampilan_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appearance, theme, and language`)
};

const id_tut_tampilan_t = /** @type {(inputs: Tut_Tampilan_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tampilan, tema, dan bahasa`)
};

/**
* | output |
* | --- |
* | "Appearance, theme, and language" |
*
* @param {Tut_Tampilan_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_tampilan_t = /** @type {((inputs?: Tut_Tampilan_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Tampilan_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_tampilan_t(inputs)
	return en_tut_tampilan_t(inputs)
});